<script>
	import LazyImgResponsive from "../components/LazyImgResponsive.svelte";

	export let id;
	export let src = "";
	export let srcDesktop = undefined;
	export let srcTablet = undefined;
	export let srcMobile = undefined;
	export let width = undefined;
	export let height = undefined;
	export let responsive = false;
	export let hideOn = [];
	export let widthDesktop = undefined;
	export let heightDesktop = undefined;
	export let widthTablet = undefined;
	export let heightTablet = undefined;
	export let widthMobile = undefined;
	export let heightMobile = undefined;

	responsive = responsive || hideOn.length > 0;

	const suffix = ".jpg";

	// width = height ? "unset" : `${width}`;
	// height = `${height}`;

	const hideOnDesktop = responsive && hideOn.includes("desktop");
	const hideOnTablet = responsive && hideOn.includes("tablet");
	const hideOnMobile = responsive && hideOn.includes("mobile");

	if (responsive) {
		srcDesktop = responsive ? `${src}_desktop` : null;
		// srcTablet = responsive ? `${src}_desktop` : null;
		// srcMobile = responsive ? `${src}_desktop` : null;
		srcTablet = responsive ? `${src}_tablet` : null;
		srcMobile = responsive ? `${src}_mobile` : null;
		src = null;
	} else {
		srcDesktop = `${src}_desktop`;
		srcTablet = `${src}_desktop`;
		srcMobile = `${src}_desktop`;
		src = `${src}${suffix}`;

		widthDesktop = undefined;
		heightDesktop = undefined;
		widthTablet = undefined;
		heightTablet = undefined;
		widthMobile = undefined;
		heightMobile = undefined;
	}

	if (srcDesktop) srcDesktop = `${srcDesktop}${suffix}`;
	if (srcTablet) srcTablet = `${srcTablet}${suffix}`;
	if (srcMobile) srcMobile = `${srcMobile}${suffix}`;
</script>

<div class="page">
	<LazyImgResponsive
		{id}
		class="spread"
		{src}
		{srcDesktop}
		{srcTablet}
		{srcMobile}
		style="width: {width}; height:{height};"
		styleDesktop="width: {widthDesktop}; height:{heightDesktop};"
		styleTablet="width: {widthTablet}; height:{heightTablet};"
		styleMobile="width: {widthMobile}; height:{heightMobile};"
		{hideOn}
	/>
</div>

<style lang="scss">
	.page {
		position: relative;
		width: fit-content;
		height: fit-content;
		box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.15);
	}

	img {
		display: block;
		width: 100%;
		height: auto;
	}
</style>
